import _defineProperty from "babel-runtime/helpers/defineProperty";
/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/* eslint-disable promise/catch-or-return */
/* eslint-disable radix */
/* eslint-disable shopify/jquery-dollar-sign-reference */
/* eslint-disable promise/no-nesting */
/* eslint-disable promise/always-return */
/**
 * Wishlist methods
 * -----------------------------------------------------------------------------
 *
 * @namespace wishlist
 */

import axios from 'axios';

export var appURL = axios.create({
  baseURL: 'https://wishlist.hulkapps.com/api/8971223095/',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-shopify-customer-id': $('body').attr('data-customerid')
  }
});

export var shareURL = axios.create({
  baseURL: 'https://wishlist.hulkapps.com/api/8971223095/',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
});

var wishlistMethods = {
  data: function data() {
    return {
      wishlist: [],
      iswishlistLoaded: false,
      isLoading: true
    };
  },


  methods: {
    _initWishlist: function _initWishlist() {
      if ($('body').attr('data-customerid') !== '') {
        app._getAppWishlist();
        app._getAllWishlistData();
      }
      app._getsharedWishlistData();
      $('body').on('click', '.creatlistCheckBox', function () {
        if ($('.creatlistCheckBox:checked').length) {
          $('.error-msg').html('');
          app.iswishlistlist = true;
        } else {
          app.iswishlistlist = false;
        }
      });
    },
    _getsharedWishlistData: function _getsharedWishlistData() {
      var _this = this;

      var sharID = app._getUrlParameter('listID');
      if (sharID) {
        shareURL.get("wishlists/" + sharID + "/items").then(function (response) {
          _this.posts = response;
          app.wishlistGroup.shareList = response.data.data;
          app.wishlistGroup.currentList.uuid = sharID;
          app.wishlistGroup.currentList.name = app.wishlistGroup.shareListTitle;
          app.loadingEvent = null;
          // assign the product cart limit
          $(app.wishlistGroup.shareList).each(function (index, product) {
            var tagArray = product.shopify_product.tags.split(',');
            var restrictCity = [];
            tagArray.forEach(function (tag) {
              if (tag.match('restricted_')) {
                var cityName = $.trim(tag.replace('restricted_', ''));
                restrictCity.push(cityName);
              }
              if (tag.match('cart-limit')) {
                var cartLimit = tag.replace('cart-limit-', '');
                product.cart_limit = parseFloat(cartLimit);
              }
              if (tag.match('prodid_')) {
                var internalId = tag.replace('prodid_', '');
                product.internalId = $.trim(internalId);
              }
              if (tag.match('pro_')) {
                var proPrice = tag.replace('pro_', '');
                product.proPrice = $.trim(proPrice);
              }
            });
            product.restricted = restrictCity;
            app.wishlistGroup.shareList[index] = product;
          });
          if (app.wishlistGroup.shareList.length > 0 && app.wishlistGroup.shareList[0].shopify_product.image) {
            var imgSrc = app.wishlistGroup.shareList[0].shopify_product.image.src; // image stored as variable
            // console.log($('meta[property="og:image"]').length)
            var nonSecureUrl = imgSrc.replace('https:', 'http:');
            $('meta[property="og:image"]').attr('content', nonSecureUrl); // assigns meta property
            $('meta[property="og:image:secure_url"]').attr('content', imgSrc);
            console.log($('meta[property="og:image"]').attr('content'), $('meta[property="og:image:secure_url"]').attr('content'));
          }
        }).catch(function (e) {
          // this.errors.push(e);
          console.log('error-->', e);
        });

        shareURL.get("wishlists/" + sharID).then(function (response) {
          var listData = response.data.data;
          app.wishlistGroup.shareListTitle = response.data.data.name;
        }).catch(function (e) {
          // this.errors.push(e);
          console.log('error-->', e);
        });
      }
    },


    /**
     * Gets the wishlist Array from Local localStorage
     */
    _getWishlist: function _getWishlist() {
      var wishlist = localStorage.getItem('user_wishlist');
      if (!wishlist) {
        return;
      }

      // set data
      app.wishlist = JSON.parse(wishlist);
    },


    /**
     * Checks if a variant exists in the wishlist
     * @param  {variant}
     * @return {boolean}
     */
    _checkWishlist: function _checkWishlist(variant) {
      var index = this.wishlist.findIndex(function (x) {
        return x.id === variant;
      });

      if (index === -1) {
        return false;
      }
      return true;
    },
    _shareWishlist: function _shareWishlist(uuid, name) {
      var _headers;

      app.iswishlistTrue = true;
      app.isShareWishlist = true;
      var hostName = window.location.hostname;
      var protocol = window.location.protocol;
      var url = protocol + "//" + hostName + "/pages/share-wishlist?listID=" + uuid;
      app.wishlistGroup.shareListTitle = name;
      app.wishlistGroup.shareURL = url;

      var config = {
        headers: (_headers = {
          'Cache-Control': 'must-revalidate'
        }, _defineProperty(_headers, "Cache-Control", 'no-cache'), _defineProperty(_headers, "Cache-Control", 'no-store'), _defineProperty(_headers, "Pragma", 'no-cache'), _headers),
        email: app.customer.email,
        name: app.customer.name,
        url: app.wishlistGroup.shareURL
      };
      appURL.post("wishlists/" + uuid + "/share", config).then(function (response) {
        return response;
      });
    },


    /**
     * Gets the Existed wishlist Array from Api
     */
    _getAppWishlist: function _getAppWishlist() {
      var _headers2,
          _this2 = this;

      var config = {
        headers: (_headers2 = {
          'Cache-Control': 'must-revalidate'
        }, _defineProperty(_headers2, "Cache-Control", 'no-cache'), _defineProperty(_headers2, "Cache-Control", 'no-store'), _defineProperty(_headers2, "Pragma", 'no-cache'), _headers2)
      };
      app.isLoading = true;
      app.iswishlistLoaded = false;
      appURL.get('wishlists', config).then(function (response) {
        _this2.posts = response.data;
        app.wishlistGroup.list = response.data.data;
        $(app.wishlistGroup.list).each(function (i, wishlist) {
          // console.log(wishlist.uuid)
          appURL.get("wishlists/" + wishlist.uuid + "/items", config).then(function (response) {
            // console.log(app.wishlistGroup.list[i]);
            app.wishlistGroup.list[i].products = response.data.data;
          }).catch(function () {
            // this.errors.push(e);
            console.log('error');
          });
        });
        setTimeout(function () {
          app.iswishlistLoaded = true;
        }, 1500);
        // console.log('Products Loaded', app.wishlistGroup.list);
      }).catch(function (e) {
        // this.errors.push(e);
        console.log('error==>', e);
      });
      setTimeout(function () {
        app.isLoading = false;
      }, 3000);
    },
    _getAllWishlistData: function _getAllWishlistData() {
      var _headers3,
          _this3 = this;

      var itemsArray = [];
      var itemshandleArray = [];
      var config = {
        headers: (_headers3 = {
          'Cache-Control': 'must-revalidate'
        }, _defineProperty(_headers3, "Cache-Control", 'no-cache'), _defineProperty(_headers3, "Cache-Control", 'no-store'), _defineProperty(_headers3, "Pragma", 'no-cache'), _headers3)
      };
      appURL.get('wishlist-items', config).then(function (response) {
        _this3.posts = response.data;
        app.wishlistGroup.cartList = response.data.data;
        $(app.wishlistGroup.cartList).each(function (i, item) {
          itemsArray.push(parseInt(item.shopify_variant_id));
          itemshandleArray.push(item.shopify_product.handle);
        });
        app.wishListedProducts = itemsArray;
        app.wishListedProductsHandles = itemshandleArray;
        app._updateHawkItem();
      }).catch(function () {
        // this.errors.push(e);
        console.log('error');
      });
    },


    /**
     * Returns the variant Url from a given variant Id
     * @param  {ListName}
     * @return {string}
     *
     */

    _createList: function _createList(event) {
      var _this4 = this;

      var listName = $(event.currentTarget).closest('.createListForm').find('[data-createList]');
      var listVal = listName.eq(0).val();
      if ($.trim(listVal)) {
        app.isLoading = true;
        app.loadingEvent = 'whisListCreating';
        $(listName).removeClass('border-danger');
        appURL.post('wishlists', {
          name: listVal
        }).then(function (response) {
          _this4.posts = response.data;
          app.wishlistGroup.list.push(response.data.data);
          $('[data-createList]').val('');
          setTimeout(function () {
            app.isLoading = false;
            app.loadingEvent = null;
          }, 300);
        }).catch(function (error) {
          // $('.error-msg').html(error.response.data.errors.name[0]);
          app._snotifyMsg('Already Exist', error.response.data.errors.name[0], 'Error');
          app.isLoading = false;
          app.loadingEvent = null;
        });
      } else {
        $(listName).addClass('border-danger');
      }
    },


    /**
     * Returns the variant Url from a given variant Id
     * @param  {productID, variantId}
     * @return {string}
     *
     */
    _addInWishlistList: function _addInWishlistList(event, productId, variantId) {
      var data = '';

      if ($('.creatlistCheckBox:checked').length === 0 || $('[data-createList]').val() === '') {
        $('.error-msg').html('Please select list to add a product');
        return false;
      }

      var listval = [];
      $.each($('.creatlistCheckBox:checked'), function (index, value) {
        listval.push($(value).val());
      });

      var price = app._formatMoney(app.selectedForwishlist.price);
      price = price.replace('$', '').replace(',', '');
      // console.log(price);

      app.isLoading = true;
      app.loadingEvent = 'whisListAdding';
      data = {
        wishlist_ids: listval,
        shopify_product_id: productId,
        shopify_variant_id: variantId,
        shopify_product_title: app.selectedForwishlist.title,
        shopify_variant_title: app.selectedForwishlist.variants[0].title,
        shopify_vendor: app.selectedForwishlist.vendor,
        shopify_price: price
      };

      appURL.post('wishlist-items', data).then(function () {
        app.iswishlistPopup = false;
        app.iswishlistlist = false;
        app._getAllWishlistData();
        $('#wishlistModal').modal('hide');
        if (app.wishlistGroup.messages.product.title === '' || app.wishlistGroup.messages.product.title === undefined) {
          app.wishlistGroup.messages.product.title = 'Successfully';
        }
        if (app.wishlistGroup.messages.product.description === '' || app.wishlistGroup.messages.product.description === undefined) {
          app.wishlistGroup.messages.product.description = 'Item has been added to your wishlist.';
        }
        app._snotifyMsg(app.wishlistGroup.messages.product.title, app.wishlistGroup.messages.product.description, 'Success');
        setTimeout(function () {
          app.isLoading = false;
          app.loadingEvent = null;
        }, 300);
      }).catch(function (e) {
        // this.errors.push(e);
        console.log('error-->', e);
      });
    },
    _getCurrentWishlist: function _getCurrentWishlist(productId, variantId) {
      appURL.get("wishlists/has-shopify-product-variant?shopify_product_id=" + productId + "&shopify_variant_id=" + variantId).then(function (response) {
        if (response.status === 200) {
          $.each(response.data.data, function (index, value) {
            $(".creatlistCheckBox[value=\"" + value.uuid + "\"]").prop('checked', true);
          });
        }
      }).catch(function (e) {
        // this.errors.push(e);
        console.log('error-->', e);
      });
    },
    _getListProduct: function _getListProduct(event, uuid, name) {
      var _headers4;

      var config = {
        headers: (_headers4 = {
          'Cache-Control': 'must-revalidate'
        }, _defineProperty(_headers4, "Cache-Control", 'no-cache'), _defineProperty(_headers4, "Cache-Control", 'no-store'), _defineProperty(_headers4, "Pragma", 'no-cache'), _headers4)
      };
      app.isLoading = true;
      app.loadingEvent = 'whisListview';
      // console.log(uuid);
      appURL.get("wishlists/" + uuid + "/items", config).then(function (response) {
        app.wishlistGroup.products = response.data.data;
        app.wishlistGroup.currentList.uuid = uuid;
        app.wishlistGroup.currentList.name = name;
        app.iswishlistTrue = true;

        // assign the product cart limit
        $(app.wishlistGroup.products).each(function (index, product) {
          var tagArray = product.shopify_product.tags.split(',');
          var restrictCity = [];
          tagArray.forEach(function (tag) {
            if (tag.match('restricted_')) {
              var cityName = $.trim(tag.replace('restricted_', ''));
              restrictCity.push(cityName);
            }
            if (tag.match('cart-limit')) {
              var cartLimit = tag.replace('cart-limit-', '');
              product.cart_limit = parseFloat(cartLimit);
            }
            if (tag.match('prodid_')) {
              var internalId = tag.replace('prodid_', '');
              product.internalId = $.trim(internalId);
            }
            if (tag.match('pro_')) {
              var proPrice = tag.replace('pro_', '');
              product.proPrice = $.trim(proPrice);
            }
          });
          product.restricted = restrictCity;
          app.wishlistGroup.products[index] = product;
        });
        setTimeout(function () {
          app.isLoading = false;
          app.loadingEvent = null;
        }, 300);
      }).catch(function () {
        app.isLoading = false;
        app.loadingEvent = null;
        // this.errors.push(e);
        console.log('error');
      });
    },
    _editWishlist: function _editWishlist(event, uuid, uname) {
      app.iswishlistTrue = true;
      app.isEditWishlist = true;
      app.wishlistGroup.currentList.uuid = uuid;
      app.wishlistGroup.currentList.name = uname;
    },
    _editList: function _editList(event, uuid) {
      var listName = $(event.currentTarget).closest('.createListForm').find('[data-createList]');
      var listVal = listName.eq(0).val();
      if ($.trim(listVal) === '' || app.wishlistGroup.currentList.name === listVal) {
        $('[data-createList]').addClass('border-danger');
        if (app.wishlistGroup.currentList.name === listVal) {
          app._snotifyMsg('Already Exist', 'You have nothing change', 'Error');
        }
        return false;
      }
      app.isLoading = true;
      app.loadingEvent = 'whisListview';
      appURL.post("wishlists/" + uuid, {
        name: listVal
      }).then(function (response) {
        // console.log('edit-->', response);
        if (response.status === 200) {
          app.iswishlistTrue = false;
          app.isEditWishlist = false;
          app._getAppWishlist();
          //   $('.sucessmsg').fadeIn().html('List Name has been Updated successfully.');
          if (app.wishlistGroup.messages.listEdit.title === '' || app.wishlistGroup.messages.listEdit.title === undefined) {
            app.wishlistGroup.messages.listEdit.title = 'List Updated';
          }
          if (app.wishlistGroup.messages.listEdit.description === '' || app.wishlistGroup.messages.listEdit.description === undefined) {
            app.wishlistGroup.messages.listEdit.description = 'List Name has been Updated successfully.';
          }
          app._snotifyMsg(app.wishlistGroup.messages.listEdit.title, app.wishlistGroup.messages.listEdit.description, 'Success');
          app.isLoading = false;
          app.loadingEvent = null;
        }
      }).catch(function (e) {
        // this.errors.push(e);
        app._snotifyMsg('Already Exist', e.response.data.errors.name[0], 'Error');
        app.isLoading = false;
        app.loadingEvent = null;
      });
    },
    _goBackList: function _goBackList() {
      app.iswishlistTrue = false;
      app.isEditWishlist = false;
      app.isShareWishlist = false;
      app.isLoading = null;
    },
    _removeAllProductsFromWishlist: function _removeAllProductsFromWishlist(id) {
      app.$snotify.confirm('Are you sure you want to delete this list?', 'Confirm', {
        closeOnClick: false,
        pauseOnHover: true,
        buttons: [{ text: 'No', bold: true }, { text: 'Yes', action: function action() {
            return app._confirmDelete(id);
          }, bold: false }]
      });
    },
    _confirmDelete: function _confirmDelete(id) {
      appURL.delete("wishlists/" + id).then(function (response) {
        if (response.status === 200) {
          var SuccessMsg = response.data.message;
          app.iswishlistTrue = false;
          app._getAppWishlist();
          app.$snotify.remove();
          app._snotifyMsg('Successfully', SuccessMsg, 'Success');
        }
      }).catch(function () {
        // this.errors.push(e);

      });
    },
    _removeFromWishlistAPP: function _removeFromWishlistAPP(event, uuid, id, name) {
      // console.log('id-->', id);
      var btnRemove = event.currentTarget;

      appURL.delete("wishlists/" + uuid + "/items/" + id).then(function (response) {
        if (response.status === 200) {
          var SuccessMsg = response.data.message;
          app._getAppWishlist();
          app._getListProduct(event, uuid, name);
          if ($(btnRemove).hasClass('btn-remove') === true) {
            app._snotifyMsg('Successfully', SuccessMsg, 'Success');
          }
        }
      }).catch(function () {
        // this.errors.push(e);

      });
    },
    _snotifyMsg: function _snotifyMsg(title, msg, type) {
      if (type === 'Success') {
        app.$snotify.success(msg, title, {
          timeout: 5000,
          showProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          buttons: [{
            text: 'Close',
            bold: true,
            closeOnClick: true
          }]
        });
      } else if (type === 'Error') {
        app.$snotify.error(msg, title, {
          timeout: 5000,
          showProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          buttons: [{
            text: 'Close',
            bold: true,
            closeOnClick: true
          }]
        });
      }
    },


    /**
     * Returns the variant Url from a given variant Id
     * @param  {productHandle, variantId}
     * @return {string}
     *
     */
    _getvariantUrl: function _getvariantUrl(productHandle, variantId) {
      return "/products/" + productHandle + "?variant=" + variantId;
    }
  }

};

export default wishlistMethods;